import React from "react";

const currency = (value) => Number(value || 0).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
});

const AddressSummary = ({ title, prefix, quote }) => (
    <div className="review-address">
        <h3>{title}</h3>
        <p>
            <strong>{quote[`${prefix}CompanyName`]}</strong><br />
            {quote[`${prefix}Address1`]}{quote[`${prefix}Address2`] && <><br />{quote[`${prefix}Address2`]}</>}<br />
            {quote[`${prefix}City`]}, {quote[`${prefix}State`]} {quote[`${prefix}PostalCode`]}<br />
            {quote[`${prefix}Country`]}<br />
            {quote[`${prefix}PhoneNumber`]}
        </p>
    </div>
);

export const QuoteReviewStep = ({ quote, selectedProducts, total, goToStep }) => (
    <div className="quote-step-content">
        <section className="quote-section review-section" aria-labelledby="review-heading">
            <div className="section-heading">
                <div>
                    <span className="section-kicker">Review</span>
                    <h2 id="review-heading">Confirm quote details</h2>
                    <p>Check the information below before creating the quote.</p>
                </div>
            </div>

            <div className="review-group">
                <div className="review-group-heading">
                    <h3>Customer and delivery</h3>
                    <button type="button" onClick={() => goToStep(1)}>Edit</button>
                </div>
                <div className="review-customer">
                    <div>
                        <span>Contact</span>
                        <strong>{quote.BillingFirstName} {quote.BillingLastName}</strong>
                        <a href={`mailto:${quote.CustomerEmail}`}>{quote.CustomerEmail}</a>
                    </div>
                    <AddressSummary title="Shipping" prefix="Ship" quote={quote} />
                    <AddressSummary title="Billing" prefix="Billing" quote={quote} />
                </div>
            </div>

            <div className="review-group">
                <div className="review-group-heading">
                    <h3>Products</h3>
                    <button type="button" onClick={() => goToStep(2)}>Edit</button>
                </div>
                <div className="review-products">
                    {selectedProducts.map((product, index) => (
                        <div className="review-product" key={`${product.ProductCode}-${index}`}>
                            <div>
                                <strong>{product.ProductCode}</strong>
                                <span>{product.ProductName}</span>
                            </div>
                            <span>Qty {product.Quantity}</span>
                            <strong>{currency(product.ProductPrice * product.Quantity)}</strong>
                        </div>
                    ))}
                    <div className="review-total">
                        <span>Total</span>
                        <strong>{currency(total)}</strong>
                    </div>
                </div>
            </div>

            {quote.Quote_Comments && (
                <div className="review-group">
                    <div className="review-group-heading"><h3>Notes</h3></div>
                    <p className="review-notes">{quote.Quote_Comments.replace(/(<([^>]+)>)/gi, "")}</p>
                </div>
            )}

            <div className="notification-note" role="note">
                <i className="fa fa-envelope" aria-hidden="true"></i>
                <div>
                    <strong>About notifications</strong>
                    <p>“Create quote and notify” saves the quote and notifies the IntrepidCS quote team and your account email. It does not email the customer.</p>
                </div>
            </div>
        </section>
    </div>
);
